import { useEffect, useRef, useState } from "react";

export default function CustomCursor() {
  const dotRef = useRef(null);
  const [hover, setHover] = useState(false);

  useEffect(() => {
    const dot = dotRef.current;
    if (!dot) return;
    let x = 0, y = 0, tx = 0, ty = 0;
    const move = (e) => { tx = e.clientX; ty = e.clientY; };
    window.addEventListener("mousemove", move);

    let raf;
    const loop = () => {
      x += (tx - x) * 0.2;
      y += (ty - y) * 0.2;
      dot.style.transform = `translate(${x}px, ${y}px) translate(-50%, -50%)`;
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const over = (e) => {
      const el = e.target;
      if (el.closest("a, button, [data-cursor='hover'], input, textarea, select, [role='button']")) setHover(true);
    };
    const out = (e) => {
      const el = e.target;
      if (el.closest("a, button, [data-cursor='hover'], input, textarea, select, [role='button']")) setHover(false);
    };
    document.addEventListener("mouseover", over);
    document.addEventListener("mouseout", out);

    return () => {
      window.removeEventListener("mousemove", move);
      document.removeEventListener("mouseover", over);
      document.removeEventListener("mouseout", out);
      cancelAnimationFrame(raf);
    };
  }, []);

  return <div ref={dotRef} className={`kb-cursor ${hover ? "hover" : ""}`} aria-hidden="true" />;
}
